import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function SystemeSecuriteInformatiquePassoire({
  variablesData,
}: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>
        {variablesData.genre_masc_complet}{" "}
        {variablesData.responsable_grand_est_precedent_nom},
      </p>
      <p>
        Nous sommes au regret de vous informer que votre système de sécurité est
        une véritable passoire. En effet, nous contrôlons votre messagerie
        interne et pouvons lire tous les messages que vous échangez avec vos
        collaborateurs.
      </p>
      <p>
        Nous pourrions modifier ces messages à notre guise et les transmettre à
        qui bon nous semble.
      </p>
      <p>
        Si vous tentez de fermer cette fenêtre ou de sortir de cette messagerie,
        vous allez provoquer la destruction de toutes vos données. 😠
      </p>
      <p>
        Nous vous recommandons vivement de nous appeler immédiatement au numéro
        suivant : 00 226 34 54 67
      </p>
      <p>Cordialement,</p>
      <MailSignature
        emetteurLogo={SystemeSecuriteInformatiquePassoire.metadata.emetteurLogo}
        emetteur={SystemeSecuriteInformatiquePassoire.metadata.emetteur}
        emetteurPoste={
          SystemeSecuriteInformatiquePassoire.metadata.emetteurPoste
        }
        emetteurEntreprise={
          SystemeSecuriteInformatiquePassoire.metadata.emetteurEntreprise
        }
      />
    </div>
  );
}

SystemeSecuriteInformatiquePassoire.metadata = {
  titre: "Votre système de sécurité informatique est une passoire",
  cleMail: "systeme_securite_informatique_passoire",
  messageTransfert: false,
  emetteur: "J.M. MORICONE",
  emetteurPoste: "Intrusions Senior Manager",
  emetteurEntreprise: "Pirate&Co",
  emetteurLogo: null,
  dateRelative: -2,
  piecesJointes: [],
} as MailMetadata;

export default SystemeSecuriteInformatiquePassoire;
